import { StaticStorage } from '$core/services/static';
import { Component, computed, inject } from '@angular/core';

@Component({
  selector: 'app-footer-nav',
  templateUrl: './footer-nav.component.html',
  styleUrls: ['./footer-nav.component.scss'],
})
export class FooterNavComponent {
  private readonly staticStorage = inject(StaticStorage);

  protected readonly block = computed(() => this.staticStorage.static().footer);
}
